import React, {useContext, useEffect, useRef} from 'react';

import Comments from './comments';
import Post from './post';
import AuthCheck from '../auth-check';
import UserContext from "../../contexts/user";
import { Button } from 'reactstrap';
import {useIntl} from "react-intl";

const Forum:React.FC<{ presentation_id: string; }> = ({ presentation_id }) => {

    const userContext = useContext(UserContext);
    const { user } = userContext;
    userContext.setRedirectPath("")
    const intl = useIntl();

    return (
        <div className="forum-contents">
            <div className="forum-container">

                    {user?
                        <>
                            <Comments presentation_id={presentation_id} />
                            <Post presentation_id={presentation_id} />
                        </>
                    :
                        <div style={{ textAlign: "center", marginTop: "45vh"}}>
                            <Button className="promt-user-login-btn  btn-primary" onClick={() => userContext.setShowLogin(true)}>  {intl.formatMessage({ id: "button.login.access" })}</Button>

                        </div>
                    }
            </div>
        </div>
  )
}

export default Forum;